

// Autogenerated 2023-05-18 09:36:21.426108
// gen_js_enum.py proto/proto/security_classification.proto src/lib/proto/security_classification.js

const AllocationClassification = {
  ALLOCATION_CLASSIFICATION_UNDEFINED: { value: 0, id: "ALLOCATION_CLASSIFICATION_UNDEFINED" },
  CASH: { value: 1, id: "CASH", label: "Cash" },
  LARGE_VALUE: { value: 2, id: "LARGE_VALUE", label: "Large Value" },
  LARGE_BLEND: { value: 3, id: "LARGE_BLEND", label: "Large Blend" },
  LARGE_GROWTH: { value: 4, id: "LARGE_GROWTH", label: "Large Growth" },
  MID_CAP_VALUE: { value: 5, id: "MID_CAP_VALUE", label: "Mid Value" },
  MID_CAP_BLEND: { value: 6, id: "MID_CAP_BLEND", label: "Mid Blend" },
  MID_CAP_GROWTH: { value: 7, id: "MID_CAP_GROWTH", label: "Mid Growth" },
  SMALL_VALUE: { value: 8, id: "SMALL_VALUE", label: "Small Value" },
  SMALL_BLEND: { value: 9, id: "SMALL_BLEND", label: "Small Blend" },
  SMALL_GROWTH: { value: 10, id: "SMALL_GROWTH", label: "Small Growth" },
  FOREIGN_LARGE_BLEND: { value: 11, id: "FOREIGN_LARGE_BLEND", label: "Foreign Large Blend" },
  FOREIGN_LARGE_VALUE: { value: 12, id: "FOREIGN_LARGE_VALUE", label: "Foreign Large Value" },
  FOREIGN_LARGE_GROWTH: { value: 13, id: "FOREIGN_LARGE_GROWTH", label: "Foreign Large Growth" },
  FOREIGN_SMALL_MID_BLEND: { value: 14, id: "FOREIGN_SMALL_MID_BLEND", label: "Foreign Small/Mid Blend" },
  FOREIGN_SMALL_MID_VALUE: { value: 15, id: "FOREIGN_SMALL_MID_VALUE", label: "Foreign Small/Mid Value" },
  FOREIGN_SMALL_MID_GROWTH: { value: 16, id: "FOREIGN_SMALL_MID_GROWTH", label: "Foreign Small/Mid Growth" },
  DIVERSIFIED_EMERGING_MARKETS: { value: 17, id: "DIVERSIFIED_EMERGING_MARKETS", label: "Diversified Emerging Markets" },
  EUROPE_STOCK: { value: 18, id: "EUROPE_STOCK", label: "Europe Stock" },
  JAPAN_STOCK: { value: 19, id: "JAPAN_STOCK", label: "Japan Stock" },
  CHINA_REGION: { value: 20, id: "CHINA_REGION", label: "China Region" },
  UTILITIES: { value: 21, id: "UTILITIES", label: "Utilities" },
  SHORT_GOVERNMENT: { value: 22, id: "SHORT_GOVERNMENT", label: "Short Government" },
  INTERMEDIATE_GOVERNMENT: { value: 23, id: "INTERMEDIATE_GOVERNMENT", label: "Intermediate Government" },
  LONG_GOVERNMENT: { value: 24, id: "LONG_GOVERNMENT", label: "Long Government" },
  ULTRASHORT_BOND: { value: 25, id: "ULTRASHORT_BOND", label: "Ultrashort Bond" },
  SHORT_TERM_BOND: { value: 26, id: "SHORT_TERM_BOND", label: "Short-Term Bond" },
  CORPORATE_BOND: { value: 27, id: "CORPORATE_BOND", label: "Corporate Bond" },
  LONG_TERM_BOND: { value: 28, id: "LONG_TERM_BOND", label: "Long-Term Bond" },
  HIGH_YIELD_BOND: { value: 29, id: "HIGH_YIELD_BOND", label: "High Yield Bond" },
  WORLD_BOND: { value: 30, id: "WORLD_BOND", label: "World Bond" },
  HIGH_YIELD_MUNI: { value: 31, id: "HIGH_YIELD_MUNI", label: "High Yield Municipals" },
  INFLATION_PROTECTED_BOND: { value: 32, id: "INFLATION_PROTECTED_BOND", label: "Inflation-Protected Bond" },
  REAL_ESTATE: { value: 33, id: "REAL_ESTATE", label: "Real Estate" },
  GLOBAL_REAL_ESTATE: { value: 34, id: "GLOBAL_REAL_ESTATE", label: "Global Real Estate" },
  GOLD: { value: 35, id: "GOLD", label: "Gold" },
  COMMODITIES_BROAD_BASKET: { value: 36, id: "COMMODITIES_BROAD_BASKET", label: "Commodities Broad Basket" },
  CRYPTOCURRENCY: { value: 37, id: "CRYPTOCURRENCY", label: "Cryptocurrency" },
  NO_CLASSIFICATION: { value: 37, id: "NO_CLASSIFICATION", label: "Unmanaged" },
};
const ClassificationType = {
  CLASSIFICATION_TYPE_UNDEFINED: { value: 0, id: "CLASSIFICATION_TYPE_UNDEFINED" },
  LARGE_CAP: { value: 1, id: "LARGE_CAP", label: "Large-Cap" },
  GOLD_: { value: 2, id: "GOLD_", label: "Gold" },
  SMALL_CAP: { value: 3, id: "SMALL_CAP", label: "Small-Cap" },
  RATED_A_OR_HIGHER: { value: 4, id: "RATED_A_OR_HIGHER", label: "Rated A or Higher" },
  RATED_BB_OR_LOWER: { value: 5, id: "RATED_BB_OR_LOWER", label: "Rated BB or Lower" },
  RATED_BBB_OR_HIGHER: { value: 6, id: "RATED_BBB_OR_HIGHER", label: "Rated BBB or Higher" },
  RATED_AA_OR_HIGHER: { value: 7, id: "RATED_AA_OR_HIGHER", label: "Rated AA or Higher" },
  MULTI_CAP: { value: 8, id: "MULTI_CAP", label: "Multi-Cap" },
  WORLD_BOND_: { value: 9, id: "WORLD_BOND_", label: "World Bond" },
  MID_CAP: { value: 10, id: "MID_CAP", label: "Mid-Cap" },
  BITCOIN: { value: 11, id: "BITCOIN", label: "Bitcoin" },
  ETHERIUM: { value: 12, id: "ETHERIUM", label: "Etherium" },
};
export { AllocationClassification,ClassificationType };
